import { postForm } from '@/utils/request'

const GET_OPENCHECK = '/shop/index/getSelfEntryOpenCheck'

export const getShopSelfEntryOpenCheck = params => {
  return postForm(GET_OPENCHECK, params)
}
